<template>
  <v-dialog v-model="dialogo" width="600" persistent>
    <v-card>
      <v-card-title
        class=" orange lighten-2"
        transition="dialog-top-transition"
        >Selecciona las opciones para compartir el archivo</v-card-title>
        <v-text-field
        style="padding-right: 20px; padding-left: 20px"
        v-model="correo"
        outlined
        class="mt-6"
        dense
        hide-details
        label="Indica el correo donde se enviara el archivo"
        :rules="reglaCorreo"
        required
        ></v-text-field>
        <v-select
        dense
          style="padding-right: 20px; padding-left: 20px; padding-top: 20px;"
          :items="arrayTiempoDeArchivo"
          label="Indica la duracion que estara disponible"
          outlined
          v-model="tiempo"
        ></v-select>
        <v-card-actions>
        <v-btn color="orange" text @click="enviarDatos(correo, tiempo)"
          >Enviar archivo</v-btn
        >
        <v-btn color="black" text @click="dialogo = false">Salir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data(){
    return{
      dialogo: false,
      reglaCorreo: [
        (v) => !!v || "Correo Requerido",
        (v) => /.+@.+\..+/.test(v) || "Correo no valido",
      ],
      arrayTiempoDeArchivo : [
        "1 Dia", "3 Dias", "7 Dias"
      ],
      correo: "",
      tiempo: ""
    }
  },
  methods: {
    activarDialogo() {
      return new Promise((resolve) => {
        this.promesaResolve = resolve;
        this.dialogo = true;
      });
    },
    enviarDatos(correo, tiempo) {
      let datos = [correo,tiempo]
      this.promesaResolve(datos);
      this.dialogo = false;
    },
  },
}
</script>

<style>

</style>